// /src/components/layout/Sidebar.tsx
import React from 'react';
import { Box, VStack, Link as ChakraLink, Icon, Text } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface NavItemProps {
  to: string;
  icon: string;
  children: React.ReactNode;
  isActive?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ to, icon, children, isActive }) => {
  return (
    <ChakraLink
      as={RouterLink}
      to={to}
      w="full"
      px={4}
      py={3}
      borderRadius="md"
      bg={isActive ? 'blue.50' : 'transparent'}
      color={isActive ? 'blue.600' : 'gray.700'}
      fontWeight={isActive ? 'semibold' : 'normal'}
      _hover={{ bg: 'blue.50', textDecoration: 'none' }}
      display="flex"
      alignItems="center"
      gap={3}
    >
      <Text fontSize="lg">{icon}</Text>
      <Text>{children}</Text>
    </ChakraLink>
  );
};

export const Sidebar: React.FC = () => {
  const { usuario } = useAuth();
  const location = useLocation();

  if (!usuario) return null;

  const isActive = (path: string) => location.pathname === path;

  return (
    <Box
      w="250px"
      h="calc(100vh - 60px)"
      bg="gray.50"
      borderRight="1px"
      borderColor="gray.200"
      p={4}
      overflowY="auto"
    >
      <VStack spacing={2} align="stretch">
        {usuario.rol === 'Admin' && (
          <>
            <NavItem to="/admin/dashboard" icon="📊" isActive={isActive('/admin/dashboard')}>
              Dashboard
            </NavItem>
            <NavItem to="/admin/clientes" icon="🏢" isActive={isActive('/admin/clientes')}>
              Clientes
            </NavItem>
            <NavItem to="/admin/estandares" icon="📋" isActive={isActive('/admin/estandares')}>
              Estándares
            </NavItem>
            <NavItem to="/admin/usuarios" icon="👥" isActive={isActive('/admin/usuarios')}>
              Usuarios
            </NavItem>
            <NavItem to="/capacitacion" icon="🎓" isActive={isActive('/capacitacion')}>
              Capacitación
            </NavItem>
          </>
        )}

        {usuario.rol === 'Consultor' && (
          <>
            <NavItem to="/proyectos" icon="📁" isActive={isActive('/proyectos')}>
              Mis Proyectos
            </NavItem>
            <NavItem to="/capacitacion" icon="🎓" isActive={isActive('/capacitacion')}>
              Capacitación
            </NavItem>
          </>
        )}

        {usuario.rol === 'Cliente' && (
          <>
            <NavItem to="/proyectos" icon="📁" isActive={isActive('/proyectos')}>
              Mis Proyectos
            </NavItem>
            <NavItem to="/capacitacion" icon="🎓" isActive={isActive('/capacitacion')}>
              Capacitación
            </NavItem>
          </>
        )}
      </VStack>
    </Box>
  );
};
